let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9vT7e")).then(() => parcelRequire('k0K29'));